export const vipSort = (requests) => {
  let vipList = requests.filter((req) => req.vip)
  return vipList
}

export const cancelRequestSort = (requests) => {
  let cancelRequestList = requests.filter((req) => !req.vip && req.cancelled_requests_count > 0)
  let collection = []
  cancelRequestList.forEach(req => {
    let added = false
    if (collection.length === 0) {
      collection.push(req)
    } else {
      for (let j = 0; j < collection.length; j++) {
        if (req.cancelled_requests_count > collection[j].cancelled_requests_count) {
          collection.splice(j, -1, req)
          added = true
          break
        }
      }
      if (!added) {
        collection.push(req)
      }
    }
  })
  return collection
}

export const generalRequestSort = (requests) => {
  let generalSort = requests.filter((req) => !req.vip && !req.cancelled_requests_count)
  return generalSort
}

export const mergeRequests = (vipList, cancelledRequestList, generalRequestList) => {
  return [...vipList, ...cancelledRequestList, ...generalRequestList]
}



// WEBPACK FOOTER //
// ./src/helpers/request_sort.js